import SeoHead, { generateMetadata } from "./SeoHead";

export default SeoHead;
export { generateMetadata };
export * from "./SeoHead.types";
